// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".avatar_ef6 {\n  -o-object-fit: contain;\n     object-fit: contain;\n  -o-object-position: center;\n     object-position: center;\n\n  border-radius: 3px;\n\n  border-radius: var(--ring-border-radius); /* This is a \"graceful degradation\" fallback, while the real value is controlled by JS */\n}\n\n.subavatar_596 {\n  position: absolute;\n  top: 15px;\n  left: 27px;\n\n  border: 1px #fff solid;\n\n  border: 1px var(--ring-content-background-color) solid;\n}\n\n.empty_1c2 {\n  display: inline-block;\n\n  box-sizing: border-box;\n\n  border: 1px solid #b8d1e5;\n\n  border: 1px solid var(--ring-borders-color);\n}\n", ""]);
// Exports
exports.locals = {
	"avatar": "avatar_ef6",
	"subavatar": "subavatar_596",
	"empty": "empty_1c2"
};
module.exports = exports;
